var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadQualificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3709_2274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67316 1.67318H18.3398V18.3398H1.67316V1.67318Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3709_2274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8893 10.0068C14.8893 12.7035 12.7032 14.8896 10.0065 14.8896C7.30976 14.8896 5.12366 12.7035 5.12366 10.0068C5.12366 7.31012 7.30976 5.12402 10.0065 5.12402C12.7032 5.12402 14.8893 7.31012 14.8893 10.0068Z",
    stroke: "white",
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4479 8.54199L9.51819 11.4717L7.56506 9.51855",
    stroke: "white",
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37322 2.39461C9.73819 2.08374 10.2748 2.08374 10.6398 2.39461L11.9087 3.51457L14.0562 3.34839C14.5342 3.31141 14.9683 3.62681 15.0808 4.09282L15.5113 5.8759L17.3876 6.99901C17.796 7.25005 17.9619 7.7604 17.779 8.20353L17.0377 9.99966L17.779 11.7958C17.9619 12.2389 17.796 12.7493 17.3876 13.0003L15.5113 14.1235L15.0808 15.9065C14.9683 16.3725 14.5342 16.6879 14.0562 16.651L11.9297 16.4864L10.6398 17.6184C10.2748 17.9293 9.73819 17.9293 9.37322 17.6184L8.08325 16.4864L5.95681 16.651C5.47882 16.6879 5.04467 16.3725 4.93217 15.9065L4.49991 14.1164L2.6268 13.0003C2.21834 12.7493 2.05252 12.2389 2.23543 11.7958L2.97664 9.99966L2.23543 8.20353C2.05252 7.7604 2.21834 7.25005 2.6268 6.99901L4.33937 5.98159L4.93217 4.09282C5.04467 3.62681 5.47882 3.31141 5.95681 3.34839L8.10428 3.51457L9.37322 2.39461Z",
    stroke: "white",
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadQualificationIcon);
export default __webpack_public_path__ + "static/media/lead-qualification-icon.c5609d9c169f41dabcc6e2f2098738ed.svg";
export { ForwardRef as ReactComponent };